import React, { useState } from "react"
import I18n from "lib/i18n"
import { getWindowLocationSearch } from "@theconversation/shared-libraries/windowLocation"
import { useVendorConsent } from "./useVendorConsent"

const onDidomiReady = (callback) => {
  if (typeof window === "undefined") return
  window.didomiOnReady = window.didomiOnReady || []
  window.didomiOnReady.push(callback)
}

const setPositiveConsentStatusForVendor = (didomiInstance, vendorId) => {
  const vendor = didomiInstance.getVendorById(`c:${vendorId}`)

  if (!vendor) {
    console.warn(`Didomi vendor not found: ${vendorId}`)
    return
  }

  const transaction = didomiInstance.openCurrentUserStatusTransaction()
  transaction.enableVendor(vendor.didomiId)
  transaction.enablePurposes(vendor.purposeIds)
  transaction.commit()
}

const ConsentGate = ({
  vendorId,
  notice = I18n.t("consent_gate.label.notice.default"),
  buttonText = I18n.t("consent_gate.button.load.default"),
  children,
}) => {
  const params = new URLSearchParams(getWindowLocationSearch())
  const bypassConsentGate = !params.get("consent_gate")

  // Note that bypassing the consent gate is the default unless `consent_gate` query string is
  // present, to give time for us to get translations ready.
  const consented = bypassConsentGate || useVendorConsent(vendorId)
  const [loadedOnce, setLoadedOnce] = useState(false)
  const [remember, setRemember] = useState(false)

  const allowed = consented || loadedOnce

  if (!allowed) {
    return (
      <div className="absolute top-0 right-0 bottom-0 left-0 flex flex-col items-center justify-center overflow-hidden bg-black p-2 font-sans text-white">
        <p className="max-w-md text-center text-sm leading-relaxed text-white max-[300px]:hidden">
          {notice}
        </p>

        <label className="mb-4 flex cursor-pointer items-center gap-2 text-sm text-white max-[360px]:hidden">
          <input
            type="checkbox"
            checked={remember}
            onChange={(e) => setRemember(e.target.checked)}
            className="h-4 w-4 rounded border-white bg-black text-white accent-white"
          />
          {I18n.t("consent_gate.label.remember_choice")}
        </label>

        <button
          type="button"
          className="rounded-full bg-white px-5 py-2 text-sm font-medium text-black"
          onClick={() => {
            if (remember) {
              onDidomiReady((didomiInstance) => {
                setPositiveConsentStatusForVendor(didomiInstance, vendorId)
              })
            }
            setLoadedOnce(true)
          }}
        >
          {buttonText}
        </button>
      </div>
    )
  }

  return <React.Fragment>{children}</React.Fragment>
}

export default ConsentGate
